import { forwardRef } from 'react';
import DorsaImage from '@/components/dorsaImage/DorsaImage';
import { IMAGE_SHAPES, IMAGE_SIZES } from '@/components/dorsaImage/imageTypes';

const FastUseSliderIndicator = forwardRef(({ data, selectedContent, handleClick }, ref) =>
    data?.map((item, index) => {
        return (
            <div
                onClick={() => handleClick(index)}
                ref={(el) => (ref.current[index] = el)}
                key={item.id}
                className={`fast-use-slider-item-container ${item.id === data?.[selectedContent]?.id && 'is-selected'}`}>
                <DorsaImage
                    src={item?.media_object?.posters?.horizontal_poster}
                    className="fast-use-slider-item-img"
                    alt={item?.media_object?.posters?.alt}
                    config={{
                        shape: IMAGE_SHAPES.HORIZONTAL,
                        size: IMAGE_SIZES.SIZE_1
                    }}
                />
            </div>
        );
    })
);

FastUseSliderIndicator.displayName = 'FastUseSliderIndicator';

export default FastUseSliderIndicator;
